import React from "react";
import RevolutionizeImg from "../../../images/location_new/fold7/react-native-uk.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose Us for React Native Development Company in UK?</h2>
            <p>
              Choosing TekRevol as your trusted{" "}
              <Link
                to="/uk/react-native-app-development-company-uk"
                rel="noopener"
                aria-label="TekRevol"
              >
                React Native app development company in UK
              </Link>{" "}
              ensures that you’re partnering with an innovative team. With years
              of experience and a proven track record of successfully delivering
              React Native solutions, we ensure your project remains competitive
              according to the latest industry standards. Our expert team of
              React app developers crafts customized solutions for your
              businesses to fulfill their unique requirements & keep the app
              optimized and up-to-date. Our dedication to cost-effectiveness
              guarantees that you receive high-quality React Native apps without
              beating your budget. Your satisfaction is of utmost importance to
              us, and we highly value your feedback, consider us to develop your
              business app that perfectly aligns with your objectives.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="react-native-app-developers-uk"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
